<button type="button" class="btn btn-{{btnContext}}" [ngClass]="{'btn-sm': !extraSmall, 'btn-xs': extraSmall}"
  (click)="click(); $event.stopPropagation()"><i class="fas fa-map"></i>&nbsp;{{'geo.map'|translate}}</button>